<template>
  <app-modal
    ref="modal"
    modal-header-title="Thông tin đơn hàng"
    size="xl"

  >
    <template v-slot:header>
      <div class="modal-header clearfix text-left">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="handlerClose()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <!-- <span class="title">{{ $t('standard_order.order_modal.modal_title') }}</span> -->
      </div>
    </template>
    <template v-slot:container>
      <div class="bg-white app-table-container">
        <!-- title -->
        <div class="row">
          <div class="col-sm-12 text-center font-weight-bold mb-2" style="font-size: 20px; color: #4472c4;">
            {{ $t('standard_order.order_modal.modal_title') }}
          </div>
        </div>
        <!-- order time -->
        <div class="row">
          <div class="col-sm-12 text-center mb-2" style="font-size: 14px; color: rgb(127 155 204);">
            {{ $t('standard_order.order_modal.label_order_time') + (entry ? entry.order_time : '') }}
          </div>
        </div>
        <!-- name -->
        <div class="row">
          <div class="col-sm-12 mb-3">
            {{ $t('standard_order.order_modal.label_customer_name') + (entry ? entry.customer_name : '') }}
          </div>
        </div>
        <!-- phone -->
        <div class="row">
          <div class="col-sm-12 mb-3">
            {{ $t('standard_order.order_modal.label_customer_phone') + (entry ? entry.customer_phone : '') }}
          </div>
        </div>
        <!-- address -->
        <div class="row">
          <div class="col-sm-12 mb-3">
            {{ $t('standard_order.order_modal.label_customer_address') + (entry ? entry.customer_address : '') }}
          </div>
        </div>
        <!-- email -->
        <div class="row">
          <div class="col-sm-12 mb-3">
            {{ $t('standard_order.order_modal.label_customer_note') + (entry ? (entry.customer_note ? entry.customer_note : '') : '') }}
          </div>
        </div>
        <!-- payment method -->
        <div class="row">
          <div class="col-sm-7 mb-3">
            <div class="row align-items-center">
              <div class="app-align-middle" style="padding-left: 7.5px;">{{ $t('standard_order.order_modal.label_payment_method') }}</div>
              <div class="flex-grow-1 ml-2">
                <app-select v-if="entry" @change=""
                                input-style="normal"
                                v-model="entry.payment"
                                :options-data="STANDARD_ORDER_LIST_CONSTANT.STANDARD_PAYMENT_METHOD" />
              </div>
            </div>
          </div>
        </div>
        <!-- status -->
        <div class="row">
          <div class="col-sm-7 mb-3">
            <div class="row align-items-center">
              <div class="app-align-middle" style="padding-left: 7.5px;">{{ $t('standard_order.order_modal.label_status') }}</div>
              <div class="flex-grow-1 ml-2">
                <app-select v-if="entry" @change=""
                                input-style="normal"
                                v-model="entry.status"
                                :options-data="STANDARD_ORDER_LIST_CONSTANT.STANDARD_ORDER_STATUS" />
              </div>
            </div>
          </div>
          <div class="col-sm-5 mb-3 text-right align-self-end">
            <button class="btn btn-success" style="height: 40px !important;"
              @click="handleAddItem"
            >
              {{ $t('student_order.order_modal.button_add_menu') }}
            </button>
          </div>
        </div>
        <!-- table items -->
        <div class="table-responsive">
          <table class="table app-table-list">
            <thead class="thead-light">
            <tr>
              <template v-for="(column, index) in columns">
                <th :key="index" :class="[column.fitSize ? 'cell-fit-content' : '']">
                  {{ column.label }}
                </th>
              </template>
            </tr>
            </thead>
            <tbody id="appTableList">
              <tr v-if="!order_items">
                <td colspan="100">
                  <span v-if="loading">
                    {{ $t("common.loading") }}
                  </span>
                  <span v-else>
                    {{ $t("common.list empty") }}
                  </span>
                </td>
              </tr>
              <tr v-else :key="item.id" :id="item.id" :data-id="entry.id" v-for="(item, itemIndex) in order_items">
                <!-- id -->
                <td class="app-align-middle text-center">
                  {{ itemIndex + 1 }}
                </td>
                <!-- menu name -->
                <td class="app-align-middle text-left">
                  {{ item.name }}
                </td>
                <!-- price -->
                <td class="app-align-middle text-right">
                  {{ convertCurrency(item.price) }}
                </td>
                <!-- currency -->
                <td class="app-align-middle text-center">
                  {{ $t("common_vn.money_unit") }}
                </td>
                <!-- quantity -->
                <td class="app-align-middle text-right" style="max-width: 100px;">
                  <app-input
                    @change=""
                    type="int"
                    input-style="normal"
                    v-model="item.quantity"/>
                  <!-- <p class=" app-table-p app-cell-tooltip mb-0">
                  </p> -->
                </td>
                <!-- total price -->
                <td class="app-align-middle text-right">
                  {{ convertCurrency(Number(item.price) * Number(item.quantity)) }}
                </td>
                <!-- delete action -->
                <td class="app-align-middle text-center app-p-none">
                  <button
                    @click="handleBtnRemoveClick(itemIndex, item)"
                    class="btn btn-danger"
                  >
                    {{ $t("common_vn.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- student menus -->
      <transition name="slide">
        <div v-if="isOpenAddMenu" class="menu-view-container">
          <div class="menu-view">
            <div v-if="restaurant_menus" class="row">
              <template v-for="(menu, menuIndex) in restaurant_menus">
                <div v-if="isNotSelectedMenu(menu.id)" :key="menu.id" class="col-sm-6 col-lg-4">
                  <div class="card" style="overflow: hidden;">
                    <img :src="menu.image.url" class="card-img-top menu-image" alt="...">
                    <div class="card-body border-top border-light">
                      <h6 class="card-title font-weight-bold menu-title mb-2" :title="menu.name">{{ menu.name }}</h6>
                      <div class="card-text menu-description" :title="menu.description">{{ menu.description }}</div>
                    </div>
                    <div class="card-footer">
                      <div class="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          :checked="isTempSelected(menu.id)"
                          :id="'checkbox' + menu.id"
                          :key="'checkbox' + menu.id"
                          @click="handleSelectItem(menu.id)"
                        />
                        <label :for="'checkbox' + menu.id">{{ $t('student_order.order_modal.label_select_menu') }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else>Loading...</div>
          </div>
          <div class="menu-footer d-flex align-items-center justify-content-between">
            <button class="btn btn-secondary" @click="isOpenAddMenu = false">{{ $t('common_vn.return') }}</button>
            <button class="btn btn-primary" @click="submitAddNewItem" :disabled="tempSelectedItems.length == 0">{{ $t('common_vn.confirm') }}</button>
          </div>
        </div>
      </transition>

      <!-- footer -->
       <div class="d-flex justify-content-between mt-4">
        <button
          @click="handleUpdateOrder"
          type="button"
          :class="['btn btn-primary']"
        >
          {{ $t("common_vn.update") }}
        </button>
      </div>
    </template>
  </app-modal>

</template>

<script>
  import AppModal from "../../../components/_common/popup/AppModal";
  import AppBasicTable from "@components/_common/list/AppBasicTable";
  import {ENDPOINT} from "../../../constants/api";
  import {STANDARD_ORDER_LIST_CONSTANT} from "../../../constants/kyy_standard_order_list";
  import {convertCurrency, getFullDateString, get} from "@utils";
  import AppCheckbox from '../../forms/AppCheckbox';

  export default {
    name: "KyyAppModalStandardOrder",
    components: {
      AppModal,
      "app-basic-table": AppBasicTable,
    },
    props : [
      "endPoint",
    ],
    methods: {
      hide(isUpdateSucces = false) {
        this.$refs.modal.hide();
        this.resetModal()
        if (isUpdateSucces) {
          this.$emit('handleUpdateSuccess');
        }
      },

      show(endPoint) {
        this.getDataEdit(endPoint)
        this.$refs.modal.show();
      },

      handlerClose() {
        this.resetModal()
      },

      async getDataEdit(endPoint) {
        await this.$request.get(endPoint).then(res => {
          if (res.hasErrors()) {
            if (res.status === 'error'){
              this.__noticeError(this.$t(res.data.error_msg));
            }
          } else {
            this.entry = res.data.data
            this.order_items = res.data.data.standard_order_items.map((orderItem) => {
              return {
                'kyy_category_menu_id': orderItem.kyy_category_menu_id,
                'name': orderItem.category_menu.name,
                'price': orderItem.price,
                'quantity': orderItem.quantity,
              }
            })
          }
        })
        await this.$request.get(ENDPOINT.UI_HELPER_GET_RESTAURANT_MENUS(this.entry.kyy_restaurant_id)).then(res => {
          if (res.hasErrors()) {
            if (res.status === 'error'){
              this.__noticeError(this.$t(res.data.error_msg));
            }
          } else {
            this.restaurant_menus = res.data.data.map((menu) => {
              menu.quantity = 1
              return menu
            })
          }
        })
        this.$nextTick(() => {
          $.each($('.app-cell-tooltip'), (index, el) => {
            // Count number of paragraph
            let paras = $(el).text().split('\n');
            let count = 0;
            $.each(paras, (index, value) => {
              count++;
            });

            // Show tooltip
            if ((count >= 3) || (el.offsetWidth < el.scrollWidth)) {
              $(el).tooltip({boundary: 'window'})
            }
          })
        });
      },

      checkLineBreak(note) {
        try {
          if (note) {
            if (note.match(/\n/g)) {
              return 'text-break';
            }
          }
        } catch(err) {
          return ''
        }
      },

      // reset modal
      resetModal() {
        this.entry = null
        this.order_items = null
        this.loading = true
        this.restaurant_menus = null
        this.isOpenAddMenu = false
        this.tempSelectedItems = []
      },

      // handle add items
      handleAddItem() {
        this.isOpenAddMenu = true
      },

      // handle delete item
      handleBtnRemoveClick(index, orderItem) {
        if (this.order_items.length == 1) {
          this.__noticeError('Required 1 menu')
          return
        }
        this.order_items = this.order_items.filter(item => item.kyy_category_menu_id !== orderItem.kyy_category_menu_id)
      },

      handleSelectItem(menuID) {
        if (this.tempSelectedItems.includes(menuID)) {
          this.tempSelectedItems = this.tempSelectedItems.filter(function(id) {
              return id !== menuID
          })
        } else {
          this.tempSelectedItems.push(menuID)
        }
      },

      isTempSelected(menuID) {
        return this.tempSelectedItems.includes(menuID)
      },

      isNotSelectedMenu(menuID) {
        for (const item of this.order_items) {
          if (item.kyy_category_menu_id == menuID) {
            return false
          }
        }
        return true
      },

      submitAddNewItem() {
        if (this.tempSelectedItems.length == 0) {
          return
        }
        let selectedItemArray = []
        for (const item of this.restaurant_menus) {
          if (this.isTempSelected(item.id)) {
            let selectedItem = {}
            selectedItem.kyy_category_menu_id = item.id
            selectedItem.name = item.name
            selectedItem.price = item.price
            selectedItem.quantity = item.quantity
            selectedItemArray.push(selectedItem)
          }
        }
        this.order_items = [...this.order_items, ...selectedItemArray]
        this.tempSelectedItems = []
        this.isOpenAddMenu = false
      },

      // handle update order after every changes
      async handleUpdateOrder() {
        let params = {}
        params.status = this.entry.status
        params.payment = this.entry.payment
        params.order_items = this.order_items
        let res = null;
        let msg = "";
        res = await this.$request.patch(this.ENDPOINT.KYY_STANDARD_ORDER_EDIT(this.entry.id), params);
        msg = this.$t("common.msg update ok")
        if (res.hasErrors()) {
          this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
        } else {
          this.__noticeSuccess(msg);
          this.hide(true)
        }
      }
    },
    data() {
      return {
        columns: [
          {name: "id", label: this.$t("common.id"), textAlign: 'text-center'},
          {name: "menu_name", label: this.$t("standard_order.menu_name"), textAlign: 'text-center'},
          {name: "price", label: this.$t("standard_order.order_modal.unit_price"), textAlign: 'text-right'},
          {name: "currency", label: this.$t("standard_order.currency"), textAlign: 'text-center'},
          {name: "quantity", label: this.$t("standard_order.item_quantity"), textAlign: 'text-right'},
          {name: "total_price", label: this.$t("standard_order.price"), textAlign: 'text-right'},
          {name: "delete", label: this.$t("common_vn.action"), textAlign: 'text-center'},
        ],
        entry: null,
        order_items: null,
        restaurant_menus: null,
        loading : true,

        // for menu selector
        isOpenAddMenu: false,
        tempSelectedItems: [],
      }
    }
  }
</script>
<style>
.menu-view-container {
  width: 100%;
  height: 100%;
  background-color: grey;
}

.menu-view {
  width: 100%; /* Full width */
  height: 100%; /* 70% height of the modal */
  background-color: #f0f0f0; /* Example background color */
  position: absolute; /* Position it absolutely within the modal */
  bottom: 0; /* Align it to the bottom of the modal */
  left: 0;
  right: 0;
  overflow-y: auto; /* If content overflows, add a scrollbar */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow */
}

.menu-view .row {
  padding: 10px 10px 0 10px;
  overflow: scroll;
  height: calc(100% - 60px);
}

.menu-footer {
  background-color: #fff;
  padding: 10px;
  border-top: 1px solid #ddd;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.menu-image {
  aspect-ratio: 4/3;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.menu-title {
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
  width: 100%;
}

.menu-description {
  text-overflow: ellipsis;
  color: #666;
  font-size: 14px;
  height: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* Slide-down transition */
.slide-enter-active, .slide-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Set height to 90% */
.slidable-content {
  height:100%;
  max-height: 90vh; /* Ensure it respects the viewport height */
  opacity: 1;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

</style>
